export default __webpack_public_path__ + "static/media/vesticard-1.98fa595e.png";